import { Filter } from "@/models/Pageable"

import { IdeaSize, IdeaStatus } from "../Idea"

export class FilterIdea extends Filter {
  q?: string
  status?: IdeaStatus
  ready?: boolean
  label?: string
  tShirtSize?: IdeaSize
  epicId?: string
  inEpic?: boolean
  projectIds?: string[]
  projectName?: string

  constructor(props) {
    super(props)

    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      q: this.q,
      status: this.status,
      ready: this.ready,
      label: this.label,
      tShirtSize: this.tShirtSize,
      epicId: this.epicId,
      inEpic: this.inEpic,
      projectIds: this.projectIds
    }

    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterIdea(props)
  }

  static createDefault() {
    return new FilterIdea({})
  }
}
